"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllDriversUniqueValidation = void 0;
const InteractionHelper_1 = require("../helpers/InteractionHelper");
const FalconValidationMethodBase_1 = require("./FalconValidationMethodBase");
/**
 * Validates that there are no duplicate drivers
 */
class AllDriversUniqueValidation extends FalconValidationMethodBase_1.FalconValidationMethodBase {
    validateInput(input, context) {
        const interaction = this.getInteraction(context);
        if (!interaction) {
            return this.validResult();
        }
        const allDrivers = InteractionHelper_1.InteractionHelper.getAllDrivers(interaction);
        if (!allDrivers || allDrivers.length === 0) {
            return this.validResult();
        }
        const duplicatesFound = allDrivers.some((d1) => {
            const d1Duplicates = allDrivers.filter((d2) => InteractionHelper_1.InteractionHelper.driversEqual(d1, d2));
            return d1Duplicates.length > 1;
        });
        if (duplicatesFound) {
            return this.invalidResult(this.getErrorMessage(context, "There are duplicate drivers"));
        }
        return this.validResult();
    }
}
exports.AllDriversUniqueValidation = AllDriversUniqueValidation;
//# sourceMappingURL=AllDriversUniqueValidation.js.map